export default __webpack_public_path__ + "static/media/port-amparo.efcaf6e0.webp";